'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _curry = require('./curry');

var _curry2 = _interopRequireDefault(_curry);

var _identity = require('./identity');

var _identity2 = _interopRequireDefault(_identity);

var _ifElse = require('./ifElse');

var _ifElse2 = _interopRequireDefault(_ifElse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ifElseOp = _ifElse2.default.operation;

function ifThen(predicate, affirmative, subject) {
  return ifElseOp(predicate, affirmative, _identity2.default, subject);
}

/**
 * Applies `affirmative` to `subject` if `predicate(subject)` is truthy.
 * Otherwise returns `subject`.
 *
 * @example
 * import ifThen from 'transmute/ifThen';
 *
 * const toJS = ifThen(
 *   subject => typeof subject.toJS === 'function',
 *   subject => subject.toJS
 * );
 *
 * toJS(List.of(1, 2, 3)) //=> [1, 2, 3]
 * toJS([1, 2, 3]) //=> [1, 2, 3]
 *
 * @param {Function} predicate
 * @param {Function} affirmative
 * @param {any} subject
 * @return {any}
 */
exports.default = (0, _curry2.default)(ifThen);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/ifThen.js
// module id = 357
// module chunks = 0 1